module.exports = __webpack_public_path__ + "static/media/song-c.c04c0482.jpg";